module.exports = __webpack_public_path__ + "img/g3.fb337f57.png";